import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import CustomBtn from '../../../../generic/CustomBtn';
import CustomInput from '../../../../generic/CustomInput';
import CustomTextarea from '../../../../generic/CustomTextarea/CustomTextarea';

const RefoData = ({ step, nextPage, prevPage, state, setState }) => {
  const { register, handleSubmit, errors, control } = useForm();
  const translate = useIntl();
  const [aboutProject, setAboutProject] = useState({ aboutProject: state.aboutProject || '' });
  const [goals, setGoals] = useState({ goals: state.goals || '' });
  const [masters, setMasters] = useState({ masters: state.masters || '' });
  const [benefits, setBenefits] = useState({ benefits: state.benefits || '' });
  const [avgTrees, setAvgTrees] = useState({ avgTrees: state.avgTrees || '' });
  const [treeSpecies, setTreeSpecies] = useState({ treeSpecies: state.treeSpecies || '' });

  const changeAvgTrees = (ev) => {
    if (ev.value) setAvgTrees({ avgTrees: Math.floor((+ev.value)) });
    else setAvgTrees({ avgTrees: '' });
  };
  const goToPreview = (data) => {
    setState({ ...state, ...data, ...benefits, ...avgTrees });
    nextPage();
  };

  if (step !== 2) {
    return null;
  }

  return (
    <div className="wizard__wrapper-form">
      <form>
        <div className="wizard__step3">
          <div className="wizard__step3-container">
            <CustomTextarea
              label={translate.formatMessage({ id: 'wizardForm.step3.projectDescription' })}
              placeholder={translate.formatMessage({ id: 'wizardForm.input-placeholder-type-here' })}
              register={register({
                required: translate.formatMessage({ id: 'wizardForm.required' }),
                maxLength: 1000,
              })}
              required
              error={errors.aboutProject}
              value={aboutProject.aboutProject}
              name="aboutProject"
              customClass="wizard__step3-textarea1"
              customClassLabel="wizard__step3-label"
              description={translate.formatMessage({ id: 'wizardForm.step1.input6.description' })}
              change={(e) => setAboutProject({ aboutProject: e.target.value || '' })}
            />
          </div>
          <div className="wizard__step3-container">
            <CustomTextarea
              label={translate.formatMessage({ id: 'wizardForm.step3.goals' })}
              placeholder={translate.formatMessage({ id: 'wizardForm.input-placeholder-type-here' })}
              register={register({
                required: translate.formatMessage({ id: 'wizardForm.required' }),
                maxLength: 1000,
              })}
              required
              error={errors.goals}
              value={goals.goals}
              name="goals"
              customClass="wizard__step3-textarea2"
              customClassLabel="wizard__step3-label"
              change={(e) => setGoals({ goals: e.target.value || '' })}
            />
          </div>
          <div className="wizard__step3-container">
            <CustomTextarea
              label={translate.formatMessage({ id: 'wizardForm.step3.masters' })}
              placeholder={translate.formatMessage({ id: 'wizardForm.input-placeholder-type-here' })}
              register={register({
                required: translate.formatMessage({ id: 'wizardForm.required' }),
                maxLength: 1000,
              })}
              required
              error={errors.masters}
              value={masters.masters}
              name="masters"
              customClass="wizard__step3-textarea2"
              customClassLabel="wizard__step3-label"
              change={(e) => setMasters({ masters: e.target.value || '' })}
            />
          </div>
          <div className="wizard__step3-container">

            <CustomTextarea
              label={translate.formatMessage({ id: 'wizardForm.step3.benefits' })}
              placeholder={translate.formatMessage({ id: 'wizardForm.input-placeholder-type-here' })}
              register={register({
                required: translate.formatMessage({ id: 'wizardForm.required' }),
                maxLength: 4000,
              })}
              required
              error={errors.benefits}
              value={benefits.benefits}
              name="benefits"
              customClass="wizard__step3-textarea2"
              customClassLabel="wizard__step3-label"
              change={(e) => setBenefits({ benefits: e.target.value || '' })}
            />
          </div>
        </div>
        <div className="wizard__step3-wrapper">
          <div className="wizard__textarea">
            <label className="wizard__label wizard__step3-label required">
              {translate.formatMessage({ id: 'wizardForm.step3.averageTreeDensity' })}
            </label>
            <div className="wizard__doc-dropzone-wrapper">
              <CustomInput
                control={control}
                rules={{
                  required: true,
                  validate: {
                    leadingZeros: (value) => +value[0] !== 0 || translate.formatMessage({ id: 'wizardForm.step3.invalidValue' }),
                    lessThan: (value) => value.toString().split(',').join('') < 100000 || translate.formatMessage({ id: 'wizardForm.step3.thisFieldIsTooBig' }),
                  },
                }}
                placeholder={translate.formatMessage({ id: 'wizardForm.input-placeholder-type-here' })}
                change={changeAvgTrees}
                error={errors.avgTrees}
                value={avgTrees.avgTrees}
                name="avgTrees"
                useNumberFormat
                numberFormatParams={{ allowNegative: false, thousandSeparator: true, decimalScale: 0 }}
                customClass="wizard__step3-input"
              />
            </div>
          </div>
          <div className="wizard__textarea">
            <CustomTextarea
              label={translate.formatMessage({ id: 'wizardForm.step3.treeSpecies' })}
              placeholder={translate.formatMessage({ id: 'wizardForm.input-placeholder-type-here' })}
              register={register({
                required: translate.formatMessage({ id: 'wizardForm.required' }),
                maxLength: 4000,
              })}
              required
              error={errors.treeSpecies}
              value={treeSpecies.treeSpecies}
              name="treeSpecies"
              customClassLabel="wizard__step3-label"
              customClass="wizard__step3-textarea5"
              change={(e) => setTreeSpecies({ treeSpecies: e.target.value || '' })}
            />
          </div>
        </div>
        <div className="wizard__btn-init">
          <CustomBtn
            label={translate.formatMessage({ id: 'button-back' })}
            handleClick={() => prevPage()}
            type="button"
            customClass="btn__cancel"
          />
          <CustomBtn
            label={translate.formatMessage({ id: 'button-next' })}
            handleClick={handleSubmit((data) => goToPreview(data))}
            type="button"
            customClass="btn__next"
          />
        </div>
      </form>
    </div>
  );
};

export default RefoData;
